import cls from "./MyGameStatsCard.module.scss";

const statItems = [
  {
    key: "turnsPlayed",
    label: "Turns Played",
    short: "TP",
    getValue: (stats) => stats.turnsPlayed || 0,
  },
  {
    key: "wins",
    label: "Wins",
    short: "W",
    getValue: (stats) => stats.wins || 0,
  },
  {
    key: "losses",
    label: "Losses",
    short: "L",
    getValue: (stats) => stats.losses || 0,
  },
  {
    key: "guessesMatched",
    label: "Guesses Matched",
    short: "GM",
    getValue: (stats) => stats.guessesMatched || 0,
  },
  {
    key: "coins",
    label: "Clothes Left",
    short: "C",
    getValue: (stats) => stats.currentCoins ?? stats.coinsLeft ?? 0,
  },
];

export default function MyGameStatsCard({ stats }) {
  const safeStats = stats || {};
  const partnerStatus = safeStats.partnerStatus || "single";

  if (!stats) {
    return (
      <section className={cls.card}>
        <div className={cls.glowPink} />
        <div className={cls.glowBlue} />

        <div className={cls.header}>
          <div>
            <p className={cls.eyebrow}>Player Overview</p>
            <h3 className={cls.title}>My Stats </h3>
          </div>
          <div className={cls.badge}>Offline Data</div>
        </div>

        <div className={cls.emptyState}>
          <div className={cls.emptyIcon}>🎮</div>
          <h4>No stats yet</h4>
          <p>Stats not available.</p>
        </div>
      </section>
    );
  }

  return (
    <section className={cls.card}>
      <div className={cls.glowPink} />
      <div className={cls.glowBlue} />

      <div className={cls.header}>
        <div>
          <p className={cls.eyebrow}>Player Overview</p>
          <h3 className={cls.title}>My Stats</h3>
        </div>

        <div
          className={`${cls.partnerBadge} ${
            partnerStatus.toLowerCase() === "single"
              ? cls.single
              : cls.partnered
          }`}
        >
          {partnerStatus}
        </div>
      </div>

      <div className={cls.highlightRow}>
        <div className={cls.highlightCard}>
          <span className={cls.highlightLabel}>Win Rate</span>
          <strong className={cls.highlightValue}>
            {safeStats.turnsPlayed
              ? `${Math.round(((safeStats.wins || 0) / safeStats.turnsPlayed) * 100)}%`
              : "0%"}
          </strong>
        </div>

        <div className={cls.highlightCard}>
          <span className={cls.highlightLabel}>Game Status</span>
          <strong className={cls.highlightValue}>Active Player</strong>
        </div>
      </div>

      <div className={cls.grid}>
        {statItems.map((item) => (
          <article key={item.key} className={cls.statCard}>
            {/* <span className={cls.statShort}>{item.short}</span> */}
            <strong className={cls.statValue}>
              {item.getValue(safeStats)}
            </strong>
            <span className={cls.statLabel}>{item.label}</span>
          </article>
        ))}
      </div>
    </section>
  );
}
